// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollableTabs_root__t5yXx","scroller":"ScrollableTabs_scroller__nonRe","scrollButton":"ScrollableTabs_scrollButton__7lPXh","tab":"ScrollableTabs_tab__JXcm9"};